import { Theme, useMediaQuery } from '@material-ui/core';

import CartItemClass from 'src/state/cart-item';

import { usePriceCartCalcs } from 'src/hooks/use-price-cart-calcs';
import { formatDiscountForDisplay } from 'shared/helpers/specials';

type UseDiscountBadgeTextProps = {
  originalPrice: string;
  bogoDiscountedPrice: string | null;
  discountedPrice: string;
  item: CartItemClass;
  shouldHideDiscounts: boolean;
  isWeightOnSale: boolean;
};

export type DiscountBadgeType = 'bogo' | 'sale' | null;

type UseDiscountBadgeTextReturn = {
  discountBadgeText: string | null;
  type: DiscountBadgeType;
};

export const useDiscountBadgeText = ({
  originalPrice,
  bogoDiscountedPrice,
  discountedPrice,
  item,
  shouldHideDiscounts,
  isWeightOnSale,
}: UseDiscountBadgeTextProps): UseDiscountBadgeTextReturn => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down(`xs`));
  const isPriceCartEnabled = usePriceCartCalcs();

  if (shouldHideDiscounts) {
    return {
      discountBadgeText: null,
      type: null,
    };
  }

  let type: DiscountBadgeType = null;
  let discountedPriceToUse = '';

  if (bogoDiscountedPrice) {
    type = 'bogo';
    discountedPriceToUse = bogoDiscountedPrice;
  } else if (!bogoDiscountedPrice && isWeightOnSale) {
    type = 'sale';
    discountedPriceToUse = discountedPrice;
  }

  const discountBadgeText = formatDiscountForDisplay(
    parseFloat(originalPrice),
    parseFloat(discountedPriceToUse),
    item,
    type,
    item.option,
    isMobile,
    isPriceCartEnabled
  );

  return {
    discountBadgeText,
    type,
  };
};
